/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { AuthService } from 'app/um/services/auth-service';
import { IContactLogConfig } from 'app/core/models/essette-interfaces';
import * as UM from 'app/um/models/essette-api';
import * as CD from 'app/cd/models/essette-api';


export interface IAuthContactLogModelData {
    authId: string;
    readonly?: boolean;
}

@autoinject()
export class ContactLogPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected authId: string | null = null;
    protected auth: UM.Auth | null = null;
    protected member?: CD.Member | null = null;

    protected contactLogConfig?: IContactLogConfig;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('um.auth.contact-log');
    }

    protected async activate(params: { authId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.authId) {
            throw new Error('Missing required parameters: authId');
        }

        this.authId = params.authId;

        await this.reload();

        this.member = this.auth?.member;

        if(this.authId && routeConfig?.navModel) {
            const title = this.i18n.tr('cd:routes.contactLog.$title', { display: this.member?.$display });
            routeConfig.navModel.setTitle(title);
        }

        this.contactLogConfig = {
            serviceRootUrl: 'um/auths',
            targetType: 'UM.Auth',
            moduleCode: 'UM',
            rollupConfig: {
                serviceRootUrl: 'cd/members',
                targetType: 'CD.Member'
            }
        };
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.authId) {
            await this.loadAuth(this.authId);
        }
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuth(authId: string): Promise<void> {
        if(!authId) return;

        const includes: string[] = [
            'member'
        ];

        try {
            this.state.beginLoad();

            const response = await this.authService.loadAuth(authId, includes);
            this.auth = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
